<template>
  <div class="pt-5">
    <Card>
      <template v-slot:title-panel>
        Datos de la solicitud
      </template>

      <div class="botones-container mt-6">
        <v-btn
          v-for="boton in botonesFiltrados"
          :key="boton.id"
          class="stats-button common-botton"
          dark
          :loading="loading"
          :disabled="loading"
          @click="cambiarEstado(boton.id)"
        >
          <v-icon small class="mr-1">{{ boton.icon }}</v-icon>
          <span>{{ boton.label }}</span>
        </v-btn>
      </div>

      <v-row>
        <v-col cols="3">
          <v-select
            v-if="isViewMode"
            :readonly="true"
            label="Estatus"
            :items="statusItems"
            v-model="solicitudLocal.statusId"
            item-text="text"
            item-value="value"
            outlined
            dense
          />
        </v-col>
      </v-row>

      <v-form ref="firstStepForm" :lazy-validation="true">
        <v-row>
          <v-col cols="12" md="6" lg="4" xl="4">
            <v-autocomplete
              label="Tipo de solicitud"
              :items="tiposSolicitud"
              v-model="solicitudLocal.tipo"
              placeholder="Requerido"
              :rules="requiredRule"
              outlined
              color="#b11f1f"
              :readonly="isViewMode"
              :no-data-text="'No se encontraron resultados...'"
              @change="onTipoChange"
            />
          </v-col>

          <v-col cols="12" md="6" lg="4" xl="4">
            <v-autocomplete
              label="Campaña / Categoria"
              :items="currentCampanias"
              v-model="solicitudLocal.categoria"
              placeholder="Requerido"
              outlined
              color="#b11f1f"
              :rules="requiredRule"
              :readonly="isViewMode"
              @change="onCampaniaChange"
            />
          </v-col>

          <v-col cols="12" md="6" lg="4" xl="4">
            <v-autocomplete
              label="Motivo"
              v-model="solicitudLocal.motivo"
              :items="currentMotivos"
              placeholder="Requerido"
              :rules="requiredRule"
              outlined
              color="#b11f1f"
              :readonly="isViewMode"
            />
          </v-col>

          <v-col v-if="isViewMode && hasRelation" cols="12">
            <div class="hyper-input" @click="goToRelation()">
              <label class="hyper-label">{{
                solicitudLocal.relationType
              }}</label>
              <div class="hyper-value">{{ solicitudLocal.relationName }}</div>
            </div>
          </v-col>

          <v-col cols="12" v-if="!hasRelation">
            <v-text-field
              label="Póliza / Solicitud / Cliente / Lead"
              v-model="relationDisplay"
              placeholder="Selecciona un registro"
              outlined
              color="#b11f1f"
              :rules="requiredRule"
              :readonly="isViewMode"
              @click="openRelationModal"
            />
          </v-col>

          <v-col cols="12">
            <v-textarea
              label="Detalle Solicitud"
              v-model="solicitudLocal.detalle"
              rows="2"
              auto-grow
              :rules="requiredRule"
              outlined
              color="#b11f1f"
              :readonly="isViewMode"
            />
          </v-col>
        </v-row>
        <v-row v-show="esLead == true">
          <v-col cols="6">
            <v-autocomplete
              label="Producto"
              :items="productosList"
              item-text="nombre"
              item-value="id"
              v-model="solicitudLocal.productoId"
              outlined
              color="#b11f1f"
              placeholder="No se encontraron resultados..."
            />
          </v-col>
        </v-row>

        <v-row v-if="!isViewMode">
          <v-col cols="12" class="text-right">
            <v-btn rounded dark class="common-botton" @click="validateStep">
              <span style="padding-right: 11%;">Siguiente</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </Card>

    <SearchModal
      :show="showRelationModal"
      :productosAseguradora="productosAseguradora"
      @onCancel="showRelationModal = false"
      @selected="selectRelation"
    />

    <v-dialog v-model="modalVisible" max-width="500px">
      <v-card>
        <v-card-title class="headline">
          {{ modalTitulo }}
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="nota"
            :label="modalLabel"
            auto-grow
            outlined
            color="#b11f1f"
            :rules="[(v) => !!v || 'Campo requerido']"
          />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="cerrarModal">Cancelar</v-btn>
          <v-btn
            color="#b11f1f"
            dark
            :loading="loading"
            @click="confirmarCambioEstado"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Card from "@/components/commondComponents/Card.vue";
import SearchModal from "@/components/solicitudes/modals/SearchModal.vue";
import { getProductosByFilters } from "@/components/productos/productosService";
import { updateSolicitud } from "@/services/solicitudService";

export default {
  components: { Card, SearchModal },
  props: {
    mode: { type: String, default: "create" },
    solicitud: { type: Object, default: () => ({}) },
    campaniasRaw: {
      type: Array,
      default: () => [],
    },
    tiposSolicitud: {
      type: Array,
      default: () => [],
    },
    productosAseguradora: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      solicitudLocal: {
        tipo: null,
        categoria: null,
        motivo: null,
        detalle: null,
        relation: null,
        relationType: "",
      },
      currentCampanias: [],
      currentMotivos: [],
      rol: JSON.parse(localStorage.getItem("roles"))?.[0]?.rol || "",
      showRelationModal: false,
      isInitialized: false,
      productosList: [],
      filtersProductos: null,
      esLead: false,
      statusItems: [
        { value: 1, text: "Nueva" },
        { value: 2, text: "En trámite" },
        { value: 3, text: "Cerrada" },
        { value: 4, text: "Folio Solicitado" },
        { value: 5, text: "Folio Obtenido" },
        { value: 6, text: "Folio Enviado" },
        { value: 7, text: "Atención Manual" },
        { value: 8, text: "Cancelada" },
        { value: 9, text: "Pendiente de autorización" },
        { value: 10, text: "Asignada" },
        { value: 11, text: "Pendiente de información" },
      ],
      nota: "",
      botones: [
        { label: "En trámite", icon: "mdi-progress-clock", id: 2 },
        {
          label: "Pendiente de información",
          icon: "mdi-information-outline",
          id: 11,
        },
        { label: "Cancelado", icon: "mdi-cancel", id: 8 },
        { label: "Cerrado", icon: "mdi-lock-check", id: 3 },
        { label: "Reabrir", icon: "mdi-folder-open", id: 10 },
      ],
      modalVisible: false,
      modalTitulo: "",
      modalLabel: "",
      estadoPendiente: null,
      selected: null,
      loading: false,
      relation: null,
    };
  },
  watch: {
    solicitud: {
      immediate: true,
      deep: true,
      async handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          await this.initializeSolicitud(newVal);
        }
      },
    },
  },
  computed: {
    isViewMode() {
      return this.mode === "view";
    },
    relationDisplay: {
      get() {
        const rel = this.solicitudLocal.relation;
        if (!rel) return "";

        let relationRaw;
        if (!this.solicitudLocal.relationRaw) relationRaw = this.solicitudLocal;
        else relationRaw = this.solicitudLocal.relationRaw;

        const nombreCompleto = (...parts) =>
          parts
            .filter((part) => part && part.toString().trim())
            .join(" ")
            .trim();
        switch (this.solicitudLocal.relationType) {
          case "Poliza":
            return `${relationRaw.id} - ${relationRaw.titular} /  ${relationRaw.productoAseguradora} / ${relationRaw.productoLead}`;
          case "Solicitud":
            return `${relationRaw.id} - ${relationRaw.nombre} / ${relationRaw.categoria}`;
          case "Cliente":
            return `${relationRaw.id} - ${nombreCompleto(
              relationRaw.nombre,
              relationRaw.apellidoPaterno,
              relationRaw.apellidoMaterno
            )}`;
          case "Lead":
            return `${relationRaw.id} - ${nombreCompleto(
              relationRaw.nombre,
              relationRaw.apellidoPaterno,
              relationRaw.apellidoMaterno
            )} / ${relationRaw.producto} / ${relationRaw.productoAseguradora}`;
          default:
            return `${relationRaw.id} - ${relationRaw.nombre ||
              relationRaw.cliente ||
              "Registro"}`;
        }
      },
    },
    requiredRule() {
      if (this.isViewMode) return [];
      return [(v) => !!v || "El campo es requerido"];
    },
    canEdit() {
      return ["ADMIN", "SUPERVISOR", "COORDINADOR", "GERENTE"].includes(
        this.rol
      );
    },
    botonesFiltrados() {
      const estadoId = this.solicitudLocal.statusId;

      const ESTADOS = {
        ASIGNADA: 10,
        EN_TRAMITE: 2,
        PENDIENTE_INFO: 11,
        CANCELADO: 8,
        CERRADO: 3,
      };

      switch (estadoId) {
        case ESTADOS.ASIGNADA:
          // Asignada => En trámite o Cancelado

          return this.botones.filter((b) =>
            [ESTADOS.EN_TRAMITE, ESTADOS.CANCELADO].includes(b.id)
          );

        case ESTADOS.EN_TRAMITE:
          // En trámite =>  Pendiente de información, Cancelado o Cerrado
          return this.botones.filter((b) =>
            [
              ESTADOS.PENDIENTE_INFO,
              ESTADOS.CANCELADO,
              ESTADOS.CERRADO,
            ].includes(b.id)
          );

        case ESTADOS.PENDIENTE_INFO:
          // Pendiente Info =>  En trámite o cancelarse
          return this.botones.filter((b) =>
            [ESTADOS.EN_TRAMITE, ESTADOS.CANCELADO].includes(b.id)
          );

        case ESTADOS.CERRADO:
          return this.botones.filter((b) => [ESTADOS.ASIGNADA].includes(b.id));

        case ESTADOS.CANCELADO:
          return this.botones.filter((b) => [ESTADOS.ASIGNADA].includes(b.id));

        default:
          return [];
      }
    },
    hasRelation() {
      if (!this.solicitudLocal.request) return false;
      const request = JSON.parse(this.solicitudLocal.request);
      return request.relationName && request.relationType && request.relationId;
    },
  },

  async mounted() {
    if (this.solicitud && Object.keys(this.solicitud).length > 0) {
      await this.initializeSolicitud(this.solicitud);
    }
  },
  methods: {
    async initializeSolicitud(solicitud) {
      this.solicitudLocal = { ...this.solicitudLocal, ...solicitud };

      if (solicitud.id) {
        this.solicitudLocal.relation = solicitud.id;
      }

      if (solicitud.request) {
        try {
          const parsed = JSON.parse(solicitud.request);

          if (parsed) {
            this.solicitudLocal = {
              ...this.solicitudLocal,
              ...parsed,
            };
          }
        } catch (err) {
          console.warn("No se pudo parsear solicitud.request:", err);
        }
      }

      if (solicitud.tipo) {
        this.currentCampanias = [
          ...new Set(
            this.campaniasRaw
              .filter((c) => c.tipificacion === solicitud.tipo)
              .map((c) => c.campania)
          ),
        ];
      }

      if (solicitud.tipo && solicitud.categoria) {
        this.currentMotivos = [
          ...new Set(
            this.campaniasRaw
              .filter(
                (c) =>
                  c.tipificacion === solicitud.tipo &&
                  c.campania === solicitud.categoria
              )
              .map((c) => c.motivo)
          ),
        ];
      }

      this.isInitialized = true;
    },
    onTipoChange() {
      if (this.isInitialized) {
        this.solicitudLocal.categoria = null;
        this.solicitudLocal.motivo = null;
      }

      this.currentCampanias = [
        ...new Set(
          this.campaniasRaw
            .filter((c) => c.tipificacion === this.solicitudLocal.tipo)
            .map((c) => c.campania)
        ),
      ];
      this.currentMotivos = [];
    },
    onCampaniaChange() {
      if (this.isInitialized && !this.solicitudLocal.motivo) {
        this.solicitudLocal.motivo = null;
      }

      this.currentMotivos = [
        ...new Set(
          this.campaniasRaw
            .filter(
              (c) =>
                c.tipificacion === this.solicitudLocal.tipo &&
                c.campania === this.solicitudLocal.categoria
            )
            .map((c) => c.motivo)
        ),
      ];
    },
    openRelationModal() {
      if (this.isViewMode) return;
      this.showRelationModal = true;
    },
    selectRelation(item, tipoBusqueda) {
      this.solicitudLocal.relation = item.id;
      this.solicitudLocal.relationType = tipoBusqueda;
      this.solicitudLocal.relationRaw = item.raw;
      this.solicitudLocal.relationUuid = item.uuid;
      this.showRelationModal = false;

      const data = item.raw;
      switch (tipoBusqueda) {
        case "Poliza":
          this.solicitudLocal = {
            ...this.solicitudLocal,
            nombre: data.nombre || "",
            apellidoPaterno: data.apellidoPaterno || "",
            apellidoMaterno: data.apellidoMaterno || "",
            fechaNacimiento: data.fechaNacimiento || "",
            rfc: data.rfc || "",
            sexo: data.genero || "",
            estadoCivil: data.estado_civil || "", // Emisiones no guarda esto
            celularMovil: data.telefonoContacto || "",
            correoElectronico: data.correoContacto || "",
            edad: data.edad || "",
            productoId: data.productoId || "",
          };
          break;

        case "Cliente":
          this.solicitudLocal = {
            ...this.solicitudLocal,
            nombre: data.nombre || "",
            apellidoPaterno: data.apellidoPaterno || "",
            apellidoMaterno: data.apellidoMaterno || "",
            fechaNacimiento: data.fechaNacimiento || "",
            rfc: data.rfc || "",
            sexo: data.genero || "",
            estadoCivil: data.estadoCivil || "",
            celularMovil: data.telefonoMovil || "",
            correoElectronico: data.correo || "",
            edad: data.edad || "",
            productoId: data.productoId || "",
            relationUuid: data.uuid || "",
          };
          break;

        case "Lead":
          this.solicitudLocal = {
            ...this.solicitudLocal,
            nombre: data.nombre || "",
            apellidoPaterno: data.apellidoPaterno || "",
            apellidoMaterno: data.apellidoMaterno || "",
            fechaNacimiento: data.fecha_nacimiento || "",
            rfc: data.rfc || "",
            sexo: data.sexo || "",
            estadoCivil: data.estadoCivil || "",
            celularMovil: data.celular || "",
            correoElectronico: data.correo || "",
            edad: data.edad || "",
            producto_aseguradora: data.productoAseguradora,
            producto_lead: data.producto,
            relationUuid: data.uuid || "",
          };

          this.filtersProductos = {
            producto_aseguradora: data.productoAseguradora,
            producto_lead: data.producto,
          };

          break;

        case "Solicitud":
          this.solicitudLocal = {
            ...this.solicitudLocal,
            nombre: data.nombre || "",
            apellidoPaterno: data.apellidoPaterno || "",
            apellidoMaterno: data.apellidoMaterno || "",
            fechaNacimiento: data.fechaNacimiento || "",
            rfc: data.rfc || "",
            sexo: data.sexo || "",
            estadoCivil: data.estadoCivil || "",
            celularMovil: data.celular || "",
            correoElectronico: data.correoElectronico || "",
            edad: data.edad || "",
            productoId: data.productoId || "",
          };
          break;

        default:
          console.warn("Tipo de búsqueda no reconocido:", tipoBusqueda);
      }
      this.$emit("clientRelation", this.solicitudLocal);
    },
    validateStep() {
      this.solicitudLocal.relationName = this.relationDisplay;
      
      if (
        this.solicitudLocal.relationType == "Lead" &&
        this.solicitudLocal.productoId == undefined
      ) {
        this.$toast.info("Selecciona un producto para el lead");
        this.esLead = true;
        this.flagLead(this.solicitudLocal);
      } else if (this.$refs.firstStepForm.validate()) {
        this.$emit("onSubmit", this.solicitudLocal);
      }
    },

    async flagLead(solicitud) {
      const filters = {
        producto_lead: solicitud.producto_lead,
        producto_aseguradora: solicitud.producto_aseguradora,
      };

      const res = await getProductosByFilters(filters);
      if (res.status == 200) {
        this.productosList = res.data.productos;
      }
    },

    cambiarEstado(estadoId) {
      // Estados que requieren nota
      const estadosConNota = [11, 3, 8]; // pendiente info, cancelado, cerrado

      if (estadosConNota.includes(estadoId)) {
        this.estadoPendiente = estadoId;
        this.modalVisible = true;

        switch (estadoId) {
          case 3:
            this.modalTitulo = "Resolver solicitud";
            this.modalLabel = "Describa la solución";
            break;
          case 8:
            this.modalTitulo = "Cancelar solicitud";
            this.modalLabel = "Describa el motivo";
            break;
          default:
            this.modalTitulo = "Motivo pendiente de información";
            this.modalLabel = "Describa el motivo";
            break;
        }
      } else {
        this.ejecutarCambioEstado(estadoId, this.nota);
      }
    },

    async confirmarCambioEstado() {
      if (!this.nota) return;
      await this.ejecutarCambioEstado(this.estadoPendiente, this.nota);
      this.cerrarModal();
    },

    async ejecutarCambioEstado(status, nota) {
      try {
        this.loading = true;
        const data = { status: status, nota: nota, motivo: nota };
        const res = await updateSolicitud(data, this.solicitud.id);

        if (res.solicitud) {
          this.$toast.success(`Estado cambiado correctamente`);
          setTimeout(() => {
            location.reload();
          }, 2000);
        } else {
          this.$toast.error("No se pudo cambiar el estado");
        }
      } catch (error) {
        this.loading = false;
        console.error("Error al cambiar estado:", error);
        this.$toast.error("Error al cambiar estado");
      } 
    },

    cerrarModal() {
      this.modalVisible = false;
      this.nota = "";
      this.estadoPendiente = null;
    },
    goToRelation() {

      switch (this.solicitudLocal.relationType) {
        case "Poliza":
          this.$router.push(`/emision/${this.solicitudLocal.relationId}`);
          break;
        case "Solicitud":
          this.$router.push(`/solicitud/${this.solicitudLocal.relationId}`);
          break;
        case "Cliente":
          this.$router.push(`/verCliente/${this.solicitudLocal.relationUuid}`);
          break;
        case "Lead":
          this.$router.push(`/bradescard/leads-bradescard/lead/${this.solicitudLocal.relationUuid}`);
          break;
      }


    },
  },
};
</script>

<style>
.botones-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 20px;
}

.stats-button {
  width: 300px;
  height: 40px !important;
  font-size: small;
  font-weight: bold;
  margin-top: 10px;
}

.hyper-input {
  border: 1px solid #b11f1f;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  background: #f7f7f7;
}

.hyper-input:hover {
  background: #fce3e3;
}

.hyper-label {
  font-size: 12px;
  color: #666;
}

.hyper-value {
  font-size: 16px;
  color: #1976d2;
  text-decoration: underline;
}
</style>
